module.exports = __webpack_public_path__ + "img/magic-background.80a0d2df.jpg";